import React, { useEffect, useState } from 'react';
import { Alert } from 'antd';
import { Link } from 'react-router-dom';
import { loginLoopCodeUrl, onPreviewLoginLoop } from '../utils/sessionExpiry';

/**
 * The api-gateway stopped a previewed app that keeps redirecting to a sign-in under its own preview address
 * (flow-helm-chart files/lua/token-exchange.lua, `flow:preview-login-loop` from Flow's preview frame,
 * utils/sessionExpiry.js). A non-modal banner says so, with a link to the service's code; the person can close it.
 */
export default function PreviewLoginLoopNotice() {
  const [loop, setLoop] = useState(null);

  useEffect(() => onPreviewLoginLoop((detail) => setLoop(detail)), []);

  if (!loop) { return null; }
  const who = loop.service ? `The "${loop.service}" app` : 'This app';
  return (
    <div style={{ position: 'fixed', top: 12, left: '50%', transform: 'translateX(-50%)', zIndex: 1100, width: 'min(560px, calc(100vw - 32px))' }}>
      <Alert
        action={<Link onClick={() => setLoop(null)} to={loginLoopCodeUrl(loop)}>Open the code</Link>}
        closable
        description={`${who} sends you to a sign-in page under its own preview address, which sends you back again. Ask the AI to fix the app's login redirect.`}
        onClose={() => setLoop(null)}
        showIcon
        title="This app keeps redirecting to its sign-in — fix its login"
        type="warning"
      />
    </div>
  );
}
